module.exports = __webpack_public_path__ + "img/login_slide_03.8b0b9654.webp";